import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinkochi() {



  const cardData =
  {
    keyword: 'Best Cab Services in Kochi',
    heading: 'Aaryan Travels: Best Cab Services in Kochi',
    headingDescription: ' Aaryan Travels delivers one of the Best Cab Services in Kochi, offering reliable and comfortable transportation for both residents and tourists across Kerala’s bustling port city. Whether you need a local city ride, airport transfer from Cochin International Airport, pilgrimage tour to Guruvayur, or a scenic trip to Munnar, Alleppey, or Thekkady, our well-maintained sedans, SUVs, and luxury vehicles ensure a smooth and enjoyable journey. With courteous drivers, transparent fares, and 24/7 service availability, Aaryan Travels makes traveling in Kochi convenient and stress-free. From corporate travel to family vacations, we are committed to providing safe and dependable cab services tailored to your needs.',

    top: 'Top Places to Visit in Kochi with Aaryan Travels',

   "topPlaces": [
  {
    "title": "Fort Kochi",
    "description": "Fort Kochi is the historic heart of the city, known for its quaint colonial streets and iconic Chinese fishing nets along the waterfront. Once ruled by the Portuguese, Dutch, and British, it still retains European-style architecture, churches, and art cafés. Visitors enjoy walking tours, heritage homestays, and vibrant street art. The evening sunset by the fishing nets is a spectacular sight. Fort Kochi is Kochi’s timeless blend of history and charm."
  },
  {
    "title": "Mattancherry Palace (Dutch Palace)",
    "description": "Built by the Portuguese and later renovated by the Dutch, Mattancherry Palace is famed for its exquisite Kerala-style murals depicting scenes from Hindu epics. The wooden ceilings, royal portraits, and rich artifacts showcase the glory of the Cochin Rajas. Its serene courtyard and Nalukettu architecture reflect Kerala’s heritage. The palace is a must-visit for art and history lovers. Mattancherry Palace is Kochi’s elegant royal legacy."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is Kochi’s most popular waterfront promenade overlooking the serene Vembanad Lake. Locals and tourists gather here for refreshing walks and boat rides. The Rainbow Bridge and Chinese Fishing Net Bridge glow beautifully at night. Street food stalls, shopping malls, and ferry terminals make it lively throughout the day. Marine Drive is Kochi’s perfect spot for leisure and sunsets."
  },
  {
    "title": "Jew Town and Paradesi Synagogue",
    "description": "Jew Town in Mattancherry is a charming lane filled with antique shops, spice markets, and heritage buildings. At its end stands the Paradesi Synagogue, one of the oldest active synagogues in the Commonwealth. Its hand-painted tiles, Belgian chandeliers, and gold pulpit reflect centuries of Jewish culture in Kerala. The peaceful ambiance takes visitors back in time. Jew Town is Kochi’s unique cultural crossroads."
  },
  {
    "title": "Kerala Kathakali Centre",
    "description": "The Kerala Kathakali Centre in Fort Kochi showcases traditional performing arts such as Kathakali, Kalaripayattu, and classical music. Visitors can watch makeup sessions before evening shows, witnessing the transformation of artists into mythological characters. The performances, with expressive gestures and powerful drumming, leave spectators spellbound. It is a great place to experience Kerala’s cultural depth. The Kathakali Centre is Kochi’s artistic soul."
  },
  {
    "title": "Hill Palace Museum",
    "description": "Hill Palace in Tripunithura was once the official residence of the Cochin royal family. Today, it is Kerala’s largest archaeological museum, housing royal artifacts, golden crowns, ornaments, and traditional weapons. The surrounding deer park and landscaped gardens make it a serene escape. History lovers admire its grandeur and well-preserved collections. Hill Palace is Kochi’s royal heritage treasure."
  },
  {
    "title": "Cherai Beach",
    "description": "Cherai Beach, located on Vypin Island, is one of Kochi’s most scenic coastlines with golden sands and gentle waves. It is ideal for swimming, dolphin spotting, and water sports. Coconut groves and backwaters surround the beach, offering a picturesque countryside feel. Sunsets here paint the sky in stunning colors. Cherai Beach is Kochi’s serene seaside retreat."
  },
  {
    "title": "Bolgatty Palace",
    "description": "Bolgatty Palace, built by the Dutch in 1744, is one of the oldest existing Dutch palaces outside Holland. Surrounded by lush gardens and overlooking the backwaters, it now serves as a heritage resort. The palace offers boating, golf, and mesmerizing lake views. Its royal charm makes it a favorite among honeymooners and tourists. Bolgatty Palace is Kochi’s luxurious heritage stay."
  },
  {
    "title": "Vypeen Island",
    "description": "Vypeen Island is a picturesque escape connected to Kochi via ferry services. The island is dotted with beaches, fishing villages, and lighthouses. Tourists visit its pristine landscapes, seafood eateries, and peaceful coastal life. Munambam Fishing Harbour and Pallipuram Fort add historical interest. Vypeen Island is Kochi’s scenic gateway to coastal bliss."
  },
  {
    "title": "Mangalavanam Bird Sanctuary",
    "description": "Mangalavanam Bird Sanctuary, located in the heart of the city, is a green lung of Kochi. The mangrove ecosystem houses migratory birds, butterflies, and a peaceful lagoon. Bird watchers visit early morning to spot rare species. Elevated walkways offer close views of nature. Despite being near urban life, it remains untouched and tranquil. Mangalavanam is Kochi’s natural oasis of biodiversity."
  }
],


   "services": [
  {
    "name": "Best Cab Services in Kochi",
    "description": "Discover the Best Cab Services in Kochi that prioritize comfort, safety, and timely pickups. Our fleet features a range of well-maintained vehicles, operated by experienced drivers who know the city inside out. Whether it’s for daily commutes, airport transfers, or special occasions, enjoy hassle-free booking, transparent pricing, and professional service tailored to your needs. We ensure smooth rides with real-time tracking and 24/7 availability, making every journey in Kochi reliable and comfortable."
  },
  {
    "name": "Top Taxi Kochi",
    "description": "Connect with the Top Taxi services in Kochi, known for punctuality, customer care, and diverse vehicle options. These taxis cater to locals and tourists alike, providing quick pickups, safe rides, and competitive fares. Whether you're headed to business meetings, city tours, or important events, top taxi providers in Kochi guarantee professionalism and convenience through easy app or call bookings."
  },
  {
    "name": "Cab Booking Kochi",
    "description": "Book your cab in Kochi effortlessly using intuitive digital platforms or phone reservations. Our Cab Booking service offers instant confirmations, multiple vehicle categories, and flexible payment options including digital wallets and cards. Whether you need a compact cab for solo travel or a larger vehicle for group outings, we ensure timely pickups, courteous drivers, and a seamless booking experience tailored to your schedule."
  },
  {
    "name": "Affordable Cab Kochi",
    "description": "Travel smart with Affordable Cab options in Kochi that deliver great value without compromising on safety or service quality. Ideal for daily travelers, students, and budget-conscious commuters, these cabs offer transparent pricing with no hidden fees. Ride in clean, well-maintained vehicles driven by professionals familiar with Kochi’s routes, ensuring efficient and economical transport across the city."
  },
  {
    "name": "Kochi Taxi Near Me",
    "description": "Locate the nearest available taxi in Kochi quickly and conveniently with our location-based service. Whether you’re at home, work, or tourist spots, Kochi Taxi Near Me connects you to nearby drivers, reducing wait times and ensuring prompt pickups. Benefit from GPS-enabled tracking, verified vehicles, and competitive fares for a reliable travel experience anywhere in the city."
  },
  {
    "name": "Local Cab Kochi",
    "description": "Navigate Kochi’s neighborhoods with ease using our Local Cab services, designed for short-distance travel and daily errands. This service is perfect for commuting to work, school, shopping centers, or quick city trips. Drivers are knowledgeable about local traffic conditions, ensuring efficient routes and timely arrivals. Available throughout the day and night, Local Cab Kochi provides dependable and affordable transportation within city limits."
  },
  {
    "name": "Outstation Cabs Kochi",
    "description": "Plan comfortable and safe outstation journeys from Kochi with our reliable Outstation Cab services. Whether traveling for business, family trips, or leisure, choose from a variety of vehicles including sedans and SUVs. Flexible rental options allow for one-way or round trips, with experienced drivers familiar with highways and interstate routes. Enjoy hassle-free bookings, well-maintained vehicles, and excellent customer support for your longer-distance travel needs."
  },
  {
    "name": "Online Cab Booking Kochi",
    "description": "Book your cab online in Kochi with ease through our user-friendly apps and websites. Enjoy instant booking confirmations, transparent fare estimates, and secure payment methods including credit/debit cards and digital wallets. Online Cab Booking Kochi offers flexibility for scheduling rides in advance or on-demand, ensuring convenience and reliability for business travelers, tourists, and locals alike."
  },
  {
    "name": "Premium Taxi Services Kochi",
    "description": "Elevate your travel experience with Premium Taxi Services in Kochi, featuring luxury vehicles such as high-end sedans, SUVs, and executive vans. Ideal for corporate clients, special events, or VIP transportation, these services include professional chauffeurs trained for discretion, safety, and customer care. Enjoy amenities like Wi-Fi, bottled water, and customized routes, making your ride in Kochi both comfortable and prestigious."
  },
  {
    "name": "Reliable Cab Kochi",
    "description": "Count on Reliable Cab services in Kochi for punctual pickups, safe rides, and courteous drivers committed to your satisfaction. Our vehicles undergo regular maintenance and sanitation, ensuring a pleasant and secure travel environment. Whether it’s a daily commute, airport transfer, or emergency ride, our reliable cab services provide 24/7 availability and real-time tracking for peace of mind throughout your journey."
  },
  {
    "name": "Trusted Cab Service Kochi",
    "description": "Choose Trusted Cab Service in Kochi, where safety, transparency, and customer trust are paramount. Every driver is background-checked and trained, and every vehicle is inspected to meet high standards. With clear pricing, dependable scheduling, and responsive support, this service is the go-to option for individuals and businesses seeking dependable and stress-free travel across Kochi."
  },
  {
    "name": "Kochi Car Hire",
    "description": "Opt for Kochi Car Hire to rent vehicles for short or long durations, perfect for business travelers, tourists, or residents needing flexible transport solutions. Choose from a diverse fleet of cars, from economy to luxury, with options for self-drive or chauffeur-driven. Enjoy transparent pricing, simple booking procedures, and reliable vehicles maintained to the highest standards for a hassle-free experience."
  },
  {
    "name": "Safe Taxi Service Kochi",
    "description": "Prioritize your safety with Safe Taxi Service in Kochi, featuring drivers trained in defensive driving and customer care. Our fleet is regularly sanitized and equipped with safety features including seat belts and GPS tracking. Ideal for families, women travelers, and senior citizens, this service ensures you reach your destination securely and comfortably at any time of day."
  },
  {
    "name": "City Cab Kochi",
    "description": "Explore Kochi effortlessly with City Cab services designed for urban travel, including office commutes, shopping trips, and sightseeing. Enjoy quick pickups, knowledgeable drivers, and affordable rates that make navigating city traffic easy and stress-free. With 24/7 availability and multiple vehicle options, City Cab Kochi is your dependable partner for all intra-city journeys."
  },
  {
    "name": "Best Taxi Deals Kochi",
    "description": "Take advantage of the Best Taxi Deals in Kochi with discounted fares, promotional packages, and special offers for frequent travelers. Whether booking daily commutes, airport transfers, or weekend trips, these deals maximize value without sacrificing quality or service. Stay updated on seasonal offers and loyalty programs to enjoy affordable, reliable taxi services throughout Kochi."
  }
],
"tableData": [
  ["Best Cab Services in Kochi", "Top Taxi Kochi"],
  ["Cab Booking Kochi", "Affordable Cab Kochi"],
  ["Kochi Taxi Near Me", "Local Cab Kochi"],
  ["Outstation Cabs Kochi", "Online Cab Booking Kochi"],
  ["Premium Taxi Services Kochi", "Reliable Cab Kochi"],
  ["Trusted Cab Service Kochi", "Kochi Car Hire"],
  ["Safe Taxi Service Kochi", "City Cab Kochi"],
  ["Best Taxi Deals Kochi", "—"]
],


 "whychoose": [
  {
    "WhyChooseheading": "Top-Rated Cab Services in Kochi",
    "WhyChoosedescription": "Aaryan Travels delivers reliable and timely cab services throughout Kochi for all your transportation needs."
  },
  {
    "WhyChooseheading": "Quick and Convenient Pickup Across Kochi",
    "WhyChoosedescription": "Our drivers are always nearby in Kochi to ensure prompt pickups and smooth rides."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Every Journey",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Kochi Routes",
    "WhyChoosedescription": "Our professional drivers know Kochi well, providing efficient and timely rides."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys as per your requirements."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and luggage needs."
  }
]

























  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide the best cab services in Kochi?',
    answer: 'Yes, Aaryan Travels offers reliable and comfortable cab services throughout Kochi, catering to both local and outstation travel.',
  },
  {
    question: 'How can I book the best cab service in Kochi with Aaryan Travels?',
    answer: 'You can book your cab easily via our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available with Aaryan Travels in Kochi?',
    answer: 'Aaryan Travels offers a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit all your travel needs.',
  },
  {
    question: 'Are Aaryan Travels cabs available for local travel as well as outstation trips from Kochi?',
    answer: 'Yes, we provide both local and outstation cab services from Kochi to various destinations.',
  },
  {
    question: 'Are the drivers experienced and familiar with Kochi routes?',
    answer: 'Definitely. Our drivers are licensed professionals and well-acquainted with Kochi and surrounding areas to ensure safe travel.',
  },
  {
    question: 'Does Aaryan Travels offer hourly and daily rental packages in Kochi?',
    answer: 'Yes, flexible hourly and daily rental cab packages are available to meet your travel requirements in Kochi.',
  },
  {
    question: 'What safety and hygiene protocols does Aaryan Travels follow for cab services in Kochi?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety measures to protect passengers.',
  },
  {
    question: 'Is Aaryan Travels cab service available 24x7 in Kochi?',
    answer: 'Yes, our cab services operate round the clock throughout Kochi.',
  },
  {
    question: 'What payment options does Aaryan Travels accept for cab bookings in Kochi?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for seamless payment.',
  },
  {
    question: 'Can I customize pickup and drop-off locations anywhere within Kochi?',
    answer: 'Yes, Aaryan Travels allows full customization of your pickup and drop points within Kochi.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Kumar',
    feedback: 'Aaryan Travels provided excellent cab service in Kochi. The driver was punctual and the vehicle was very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Nair',
    feedback: 'Had a wonderful experience with Aaryan Travels during my trip in Kochi. Highly recommend their services!',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Services in Kochi",
  "image": "https://aaryantravels.com/assets/images/best-cab-kochi.jpg", // replace with your actual image URL
  "description": "Top-rated and affordable cab services in Kochi by Aaryan Travels. Book local, outstation, and premium taxis online for a safe and reliable ride. Available 24x7 for all your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7", // example rating, update as needed
    "ratingCount": "3800", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "600", // example price, adjust accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/best-cab-services-kochi"
  }
};







  return (
    <div>


<Helmet>
  <title>Best Cab Services in Kochi | Affordable & Reliable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Top-rated and affordable cab services in Kochi by Aaryan Travels. Book local, outstation, and premium taxis online for a safe and reliable ride. Available 24x7 for all your travel needs."
  />
  <meta
    name="keywords"
    content="Best Cab Services in Kochi, Top Taxi Kochi, Cab Booking Kochi, Affordable Cab Kochi, Kochi Taxi Near Me, Local Cab Kochi, Outstation Cabs Kochi, Online Cab Booking Kochi, Premium Taxi Services Kochi, Reliable Cab Kochi, Trusted Cab Service Kochi, Kochi Car Hire, Safe Taxi Service Kochi, City Cab Kochi, Best Taxi Deals Kochi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinkochi;